import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000080;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
`;

export const ModalContent = styled.div`
  background-color: #ffffff;
  padding: ${viewSizeCalculator(2.1875)};
  border-radius: ${viewSizeCalculator(1.2)};
  text-align: left;
  width: ${({ width }) => `${viewSizeCalculator(width ? width : 35)}`};
  position: relative;
`;

export const EmailInput = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.9)}`};
  font-weight: 400;
  background-color: transparent;
  width: 100%;
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.8)}`};
  margin-top: ${viewSizeCalculator(0.9)};
  border: 1px solid #ccc;
  border-radius: ${viewSizeCalculator(1)};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${viewSizeCalculator(0.4)};
`;

export const Input = styled.input`
  background-color: transparent;
  height: ${viewSizeCalculator(2)};
  outline: none;
  border: none;
  width: ${(props) =>
    props.isFullWidth ? "100%" : `${viewSizeCalculator(12)}`};
  font-size: ${() => `${viewSizeCalculator(0.9)}`};
`;

export const ModalFooter = styled.div`
  width: 100%;
  margin-top: ${viewSizeCalculator(2.8)};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${viewSizeCalculator(1.5)};
`;

export const EmailPill = styled.div`
  padding: ${() =>
    `${viewSizeCalculator(0.2)} ${viewSizeCalculator(0.2)} ${viewSizeCalculator(
      0.2,
    )} ${viewSizeCalculator(1)}`};
  border: 1px solid #E35B42;
  border-radius: ${viewSizeCalculator(1.2)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fdddd7;
  cursor: pointer;
`;

export const EmailText = styled.p`
  margin-right: ${viewSizeCalculator(0.5)};
`;

export const PreviouslySharedContainer = styled.div`
  margin: ${viewSizeCalculator(1.2)} 0rem;
`;
export const PreviouslySharedTitle = styled.p`
  font-weight: 500;
  font-size: ${() => `${viewSizeCalculator(1.05)}`};
  margin-bottom: ${viewSizeCalculator(0.5)};
`;

export const PreviouslySharedItem = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${viewSizeCalculator(-0.5)};
  cursor: pointer;
  max-width: max-content;
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)}`};
  padding-right: ${viewSizeCalculator(0.8)};
  border-radius: ${viewSizeCalculator(100)};
  &:hover {
    background-color: #f9f9f9;
  }
`;

export const EmailAvatar = styled.div`
  width: ${viewSizeCalculator(1.8)};
  height: ${viewSizeCalculator(1.8)};
  background-color: red;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${viewSizeCalculator(0.8)};
  font-size: ${() => `${viewSizeCalculator(1)}`};
  font-weight: bold;
  background-color: ${(props) => props.bgColor};
`;

export const SharedEmailText = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.9)}`};
`;

export const DropdownContainer = styled.div`
  position: relative;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  background-color: transparent;
  cursor: pointer;
  border: 1px solid #ccc;
  margin-top: ${viewSizeCalculator(1.5)};
`;

export const MessageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${viewSizeCalculator(0.8)};
`;

export const Image = styled.img`
  width: ${viewSizeCalculator(5)};
`;

export const MessageTitle = styled.h2`
  font-size: ${() => `${viewSizeCalculator(1.2)}`};
`;

export const MessageDescription = styled.p`
  color: #676767;
  font-size: ${() => `${viewSizeCalculator(1.1)}`};
`;

export const ErrorContainer = styled.div`
  height: ${viewSizeCalculator(2.2)};
  padding: 0.45rem 0.25rem;
`;

export const Label = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 0.625rem;
  font-size: ${() => `${viewSizeCalculator(0.8)}`};
  color: ${({ isError }) => (isError ? "#E35B42" : "#636363")};
`;
